import React from 'react';
import { copyToClipboard } from '../../../utils/commonFunction';
import { blockExplorerUrl } from '../../../utils/wagmiConfig';

const shortenTxHash = (hash) => {
    const value = String(hash || '');
    if (value.length <= 16) return value;
    return `${value.slice(0, 10)}…${value.slice(-8)}`;
};

const HashRow = ({ label, hash }) => (
    <div className="flex flex-col gap-1.5 rounded-lg border border-zinc-100 bg-white px-3 py-2.5 dark:border-zinc-800/80 dark:bg-zinc-950/50 sm:flex-row sm:items-center sm:justify-between">
        <span className="text-[11px] font-semibold uppercase tracking-wide text-zinc-500 dark:text-zinc-500">
            {label}
        </span>
        <div className="flex min-w-0 items-center gap-1.5">
            <span
                className="truncate font-mono text-[12px] text-zinc-800 dark:text-zinc-200"
                title={hash}
            >
                {shortenTxHash(hash)}
            </span>
            <button
                type="button"
                onClick={() => copyToClipboard(hash)}
                className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-zinc-200 bg-zinc-50 text-zinc-600 transition hover:border-teal-300 hover:text-teal-700 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-400 dark:hover:border-teal-700 dark:hover:text-teal-400"
                title="Copy transaction hash"
                aria-label="Copy transaction hash"
            >
                <i className="fa-regular fa-copy text-[10px]" />
            </button>
            {blockExplorerUrl ? (
                <a
                    href={`${blockExplorerUrl}/tx/${hash}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md border border-zinc-200 bg-zinc-50 text-zinc-600 transition hover:border-teal-300 hover:text-teal-700 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-400 dark:hover:border-teal-700 dark:hover:text-teal-400"
                    title="View on block explorer"
                >
                    <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" />
                </a>
            ) : null}
        </div>
    </div>
);

const TaskTransactionHashes = ({ entries = [], escrowId = null }) => {
    if (!entries.length) {
        if (!escrowId) return null;
        return (
            <section className="rounded-xl border border-zinc-200 bg-white p-5 dark:border-zinc-800 dark:bg-zinc-950/40">
                <h2 className="text-sm font-semibold text-zinc-900 dark:text-white">
                    On-chain transactions
                </h2>
                <p className="mt-2 text-sm text-zinc-500 dark:text-zinc-400">
                    Transaction hashes will appear here after escrow is funded on-chain.
                </p>
            </section>
        );
    }

    return (
        <section className="rounded-xl border border-zinc-200 bg-white p-5 dark:border-zinc-800 dark:bg-zinc-950/40">
            <h2 className="text-sm font-semibold text-zinc-900 dark:text-white">
                On-chain transactions
            </h2>
            <p className="mt-0.5 text-xs text-zinc-500 dark:text-zinc-500">
                Blockchain transaction hashes for this task
            </p>
            <div className="mt-4 space-y-2">
                {entries.map((entry) => (
                    <HashRow key={`${entry.label}-${entry.hash}`} label={entry.label} hash={entry.hash} />
                ))}
            </div>
        </section>
    );
};

export default TaskTransactionHashes;
